<template>
  <!-- 继续率统计 -->
  <Modal v-model="visible" :mask-closable="false" title="续期结算规则" :footer-hide="true" width="1000" class="my-modal">
    <div class="rule-title">续期系数发放规则介绍：</div>
    <div class="table">
      <div class="tr head">
        <div class="td big-td">产品区分</div>
        <div class="td">续期时间</div>
        <div class="td">继续率要求</div>
        <div class="td">续期服务费发放比例</div>
      </div>
      <div class="tr" v-for="(item1, i) in ruleList" :key="i">
        <div class="td big-td">{{ item1.name }}</div>
        <div class="child-box">
          <div class="tr" v-for="(item2, ii) in item1.payNums" :key="ii">
            <div class="td">{{ item2.payNumDesc }}</div>
            <div class="child-box">
              <div class="tr" v-for="(item3, iii) in item2.renewalRates" :key="iii">
                <div class="td">
                  <template v-if="item1.isCalRate">
                    <template v-if="item3.max && item3.min">
                      <span v-if="item3.min">{{ item3.min }}%≤</span>
                      <span>{{ item1.type == 1 ? '产品继续率' : '整体继续率' }}</span>
                      <span v-if="item3.max">&lt;{{ item3.max }}%</span>
                    </template>
                    <template v-else-if="item3.min">
                      <span>{{ item1.type == 1 ? '产品继续率' : '整体继续率' }}</span>
                      <span v-if="item3.min">≥{{ item3.min }}%</span>
                    </template>
                  </template>
                  <span v-else>无继续率要求</span>
                </div>
                <div class="td">发放{{ item3.sendRate }}%续期服务费</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rule-title">继续率的计算公式：</div>
    <p>a.13个月保费继续率=上年同期生效的个人长期险期缴保单生效后第13个月+60天宽限期内的实收保费/上年同期生效的个人长期险期应收保费×100%。</p>
    <p>b.25个月保费继续率=前年同期生效的个人长期险期缴保单生效后第25个月+60天宽限期内的实收保费/上年同期生效的个人长期险期应收保费×100%。</p>

    <div class="rule-title">继续率统计口径：</div>
    <p>a.理赔终止/犹豫期内退保/豁免保费/趸交业务不纳入统计。</p>
    <p>b.犹豫期外退保业务纳入分母（应收保费）、不纳入分子（实收保费）。</p>
    <p>c.考核以所有商品为维度，不含1年期商品。</p>

    <div class="rule-title">继续率奖金发放规则：</div>
    <div class="table">
      <div class="tr head">
        <div class="td big-td">渠道类型</div>
        <div class="td big-td">产品类型</div>
        <div class="td big-td">续期服务费发放时间</div>
        <div class="td big-td">续期服务费发放比例</div>
      </div>
      <div class="tr">
        <div class="td big-td">企业类用户</div>
        <div class="td big-td">所有产品</div>
        <div class="td big-td">宽限期后第2个月10日</div>
        <div class="td big-td">100%</div>
      </div>
    </div>

    <div class="rule-title">特别说明：</div>
    <p>a.续期缴费确认信息由保险公司发出，可能存在一定延误情况</p>

    <div class="rule-title">举例：</div>
    <p>2019年9月1日-2019年9月30日生效的保单，续期缴费日为2020年9月1日-2020年11月30日，服务费生效（下发）日为2021年1月10日</p>
  </Modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      ruleList: []
    };
  },
  mounted() {},
  methods: {
    open() {
      const close = this.$notice.loading('加载中');
      this.$http({
        url: '/buz/renewalRate/queryRuleList',
        type: 'PUT',
        data: {}
      })
        .then(res => {
          this.ruleList = res.data;
          this.visible = true;
        })
        .finally(() => {
          close();
        });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './ruleExplainModal.scss';
</style>
